<template>
  <div class="first_page mobile_div section_bg pb-2">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <section v-if="is_load"   class="pt-1 ">
      <div class="container mobile_div mt-3">
        <div class="section_header mobile_div">
          <h4 >Исполнители</h4>
        </div>
      <div class="section_header mobile_div nocenter">
        <div class="row">
          <div class="col-12 col-md-6">
            <label class=" m-3">Выберите услугу</label>
          </div>
          <div class="col-12 col-md-6">
            <select class="form-control" @change="changeService()" v-if="services.length>0"   v-model="choose_service" >
              <option value="0">Все услуги</option>
              <option v-for="(service,service_index) in services"  :value="service.last_id" :key="service.last_id">{{ service.name}}</option>

            </select>
          </div>

        </div>
      </div>
        <div class="card alert alert-warning" v-if="is_error">
          <p>{{ error_message }}</p>
        </div>
       <div class="section_header nocenter mobile_div">
         <div class="row col-12 d-flex justify-content-center" v-if="users.length>0">

           <div class="col-6 col-sm-6 col-lg-2 col-md-3 item_card_container  "  v-for="(user,user_index) in users" :key="user_index" >
             <div class="item_card_mini">
               <div class="item_data">
                 <div class="shop-item-image">
                   <router-link class="" :to="{name: 'user_page_main', params: {user_id:user.last_id }}" tag="a" ><img :src="image_url+user.avatar"  alt="..."></router-link>
                 </div>


                 <div class="shop-item-title d-flex justify-content-center"> <router-link class=" " :to="{name: 'user_page_main', params: {user_id:user.last_id }}" tag="a" > {{ user.name}}</router-link></div>
                 <div class="container mt-2" v-if="user.rating">
                   <div class="row">
                     <div class="col-md-4 col-12 mx-auto d-flex align-items-center justify-content-center">
                       <p class="text-center"><router-link tag="a" :to="{name:'user_page_main',params: { user_id: user.last_id }}"><span class="badge badge-circle badge-info">{{ user.rating}}</span></router-link></p>
                     </div>
                   </div>
                 </div>
                 <!--            <div class="row text-center">-->

                 <!--                <h3>{{ item.count}}</h3>-->

                 <!--            </div>-->
                 <!--            <div class="row mb-2">-->
                 <!--              <div class="col-5">-->
                 <!--                <button type="button" @click="changeType(item_index,'-')" class="btn" v-if="count_arr['last_id_'+item.last_id]>0">-</button>-->
                 <!--              </div>-->

                 <!--              <div class="col-5">-->
                 <!--                <button type="button" @click="changeType(item_index,'+')" class="btn">+</button>-->

                 <!--              </div>-->
                 <!--            </div>-->

                 <router-link class="btn btn-sm" :to="{name: 'user_page_main', params: {user_id:user.last_id }}" tag="a" > открыть</router-link>
               </div>
             </div>

           </div>

         </div>
         <div class="row mt-4 mb-4 d-flex justify-content-center" v-if="users.length>0">
           <p>Показано  {{ offset}} из  {{ count}}</p>
         </div>
         <div class="row mt-4 d-flex justify-content-center" v-if="users.length>0">
           <div class="col-6  d-flex justify-content-center " >

             <button v-if=" count>0 && offset-users.length>0" @click="prevBtn" class="btn">Назад</button>
             <button v-if="!( count>0 && offset-users.length>0)" disabled   class="btn disabled">Назад</button>
           </div>

           <div class="col-6  d-flex justify-content-center" >
             <button @click="nextBtn" v-if="count>offset" class="btn">Вперед</button>
             <button   v-if="!(count>offset)" disabled class="btn ">Вперед</button>
           </div>


         </div>
       </div>
      </div>

    </section>
  </div>
</template>

<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";




var Avatar = require('vue-avatar');


export default {
  name: 'Users',

  components: {LoadingBlock},
  data() {
    return {
      "is_load":false,
      "image_url":"",
      "services":[],
      "choose_service":0,
      "users":[],
      "count":0,
      "offset":0,
      "limit":12,
      "next_offset":0,

      "is_error":false,
      "error_message":"",
    }
  },
  mounted() {

    var app=this;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadUsers();


  },
  methods: {
    changeService(){
      var app=this;
      app.offset=0;
      app.users=[];
      app.loadUsers();

    },
    prevBtn(){
     var app=this;
     if(app.count>0 && app.offset-app.users.length>0){
       app.is_load=false;
       var current_offset=app.offset;

       app.offset=current_offset-app.users.length-app.limit;


       app.loadUsers();
     }
    },
    nextBtn(){
      var app=this;
      if(app.count>app.offset){
        app.is_load=false;
        app.loadUsers();
      }
    },
    loadUsers(){
      var app=this;
      var limit=app.limit;
      var offset=app.offset;


      var service_id=app.choose_service;
      Api.loadUsersList(limit,offset,service_id,function(data){

        app.services=data.services;
        app.users=null;
        app.users=data.developers;
        app.count=data.count;

        app.offset=data.offset;
        app.is_load=true;
      });
    }




  }
};
</script>
